import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND, IS_EUROPE, SUPPORT_EMAIL, COMPANY, localePath } from '../config/region';
import { openCookieSettings } from '../utils/consent';
import { t } from '../i18n';
import './SiteFooter.css';

const TelegramIcon = () => (
  <svg className="sf__tg-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.96 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);

const TG_GROUP = 'https://t.me/+4LsIU0kLAc1jN2My';

const SiteFooter = () => {
  return (
    <footer className="sf">
      {/* Russia only: the community chat and the support mailbox are both Russian-language, and
          the ИП block below is a disclosure a registered Russian sole trader has to publish. */}
      {!IS_EUROPE && (
        <div className="sf__row">
          <a
            href={TG_GROUP}
            target="_blank"
            rel="noopener noreferrer"
            className="sf__link"
          >
            <TelegramIcon /> Telegram
          </a>
        </div>
      )}
      {/* A contact address stays in both regions — an EU-facing site is expected to publish one,
          and it is the only channel left in Plotex now that the Telegram group is gone. */}
      <div className="sf__row">
        <a href={`mailto:${SUPPORT_EMAIL}`} className="sf__link">
          {SUPPORT_EMAIL}
        </a>
      </div>
      <div className="sf__pages">
        <a href={localePath('/blog/about-us')} className="sf__link">{t('О нас')}</a>
        <a href={localePath('/blog/cooperation')} className="sf__link">{t('Сотрудничество')}</a>
      </div>
      {/*
        The europe row is the set the compliance instruction requires on every page: Terms,
        Privacy, Cookie policy, Copyright/DMCA and a contact route — plus the two the instruction
        adds elsewhere and that have to be reachable from the footer, the operator identification
        page and the CCPA opt-out.
      */}
      <div className="sf__legal">
        <Link to="/terms" className="sf__legal-link">{t('Пользовательское соглашение')}</Link>
        <Link to="/privacy" className="sf__legal-link">{t('Политика конфиденциальности')}</Link>
        <Link to="/cookies" className="sf__legal-link">
          {IS_EUROPE ? t('Политика cookie') : t('Согласие на Cookie')}
        </Link>
        {IS_EUROPE && (
          <>
            <Link to="/copyright" className="sf__legal-link">{t('Правообладателям')}</Link>
            <Link to="/refund" className="sf__legal-link">{t('Политика возврата')}</Link>
            <Link to="/legal" className="sf__legal-link">{t('Юридическая информация')}</Link>
            {/* CCPA/CPRA requires this exact route to be reachable from the footer */}
            <Link to="/privacy-request" className="sf__legal-link">
              {t('Не продавать и не передавать мои данные')}
            </Link>
            {/* Consent has to be changeable at any time, not only on first visit */}
            <button type="button" className="sf__legal-link sf__legal-btn" onClick={openCookieSettings}>
              {t('Настройки cookie')}
            </button>
          </>
        )}
        {/* The public offer is a Russian contract form with no European counterpart. Refund and
            copyright are published in both regions, from the europe block above. */}
        {!IS_EUROPE && (
          <>
            <Link to="/oferta" className="sf__legal-link">{t('Публичная оферта')}</Link>
            <Link to="/author-agency-agreement" className="sf__legal-link">Агентский договор</Link>
            <Link to="/refund" className="sf__legal-link">{t('Политика возврата')}</Link>
            <Link to="/copyright" className="sf__legal-link">{t('Правообладателям')}</Link>
          </>
        )}
      </div>
      {/* An EU-facing service has to be identifiable on the page, not only behind a link */}
      <div className="sf__info">
        {!IS_EUROPE && (
          <>
            <span>{t('Индивидуальный предприниматель')}</span>
            <span>Лебедянский Евгений Павлович</span>
            <span>ИНН: 504232534204</span>
            <span>ОГРНИП: 326508100140604</span>
            <span>Московская обл., Сергиево-Посадский р-н, РП Богородское</span>
          </>
        )}
        {/* Name and registration number only. The registered address is long enough to dominate
            the footer on a phone, and an EU-facing site satisfies its identification duty by
            publishing it somewhere reachable from every page — which /legal is. */}
        {IS_EUROPE && COMPANY && (
          <>
            <span>{COMPANY.legalName}</span>
            <span>{COMPANY.registrationLabel}: {COMPANY.registrationNumber}</span>
          </>
        )}
        <span>{BRAND} © 2026</span>
      </div>
    </footer>
  );
};

export default SiteFooter;
